import QueryString from 'query-string';
const ARTICLE_PAGE_CONTTYPES = ['article', 'mgznart', 'pctrart', 'comment'];

/**
 * Insightsで集計対象のアーティクル系のページのみ
 *
 * @param contType
 * @param mediaId
 * @param pageType
 * @returns
 */
export const makeSsJoinParamByArticlePage = (
  contType?: string,
  mediaId?: string
): { type: string; id: string } | undefined => {
  if (!mediaId || !contType) {
    return undefined;
  }
  if (ARTICLE_PAGE_CONTTYPES.indexOf(contType) === -1) {
    return undefined;
  }
  const pageType = getPageType(contType);
  if (!pageType) {
    return undefined;
  }
  const queryObject = {
    shannon_service_id: 'news',
    shannon_media_id: mediaId,
    page_type: pageType
  };
  return {
    type: 'querystring',
    id: QueryString.stringify(queryObject)
  };
};

const getPageType = (contType: string) => {
  switch (contType) {
    case 'article':
    case 'mgznart':
      return 'article';
    case 'pctrart':
      return 'photo';
    case 'comment':
      return 'comment';
    default:
      return null;
  }
};

interface ContTypeMap {
  contType: string;
  pageType: string;
}

const contTypeMapTableForExpert: { [key: string]: ContTypeMap } | undefined = {
  author: { contType: 'news_byl', pageType: 'media_top' },
  auth_my: { contType: 'news_byl', pageType: 'media_top' },
  auth_other: { contType: 'news_byl', pageType: 'media_top' },
  creator: { contType: 'expert', pageType: 'media_top' },
  cre_my: { contType: 'expert', pageType: 'media_top' },
  cre_other: { contType: 'expert', pageType: 'media_top' },
  author_article: { contType: 'news_byl', pageType: 'article' },
  creator_article: { contType: 'expert', pageType: 'article' }
};

export const makeSsJoinParamByExpertPage = (
  contType?: string,
  mediaId?: string,
  articleId?: string,
  isPay?: boolean,
  isPurchesed?: boolean
): { type: string; id: string } | undefined => {
  if (!mediaId || !contType) {
    return undefined;
  }
  const contTypeMap = contTypeMapTableForExpert[contType];
  if (!contTypeMap) {
    return undefined;
  }

  return {
    type: 'querystring',
    id: QueryString.stringify({
      shannon_service_id: contTypeMap.contType,
      shannon_media_id: mediaId,
      page_type: contTypeMap.pageType,
      shannon_article_id: articleId,
      shannon_pay: isPay,
      is_purchased: isPurchesed
    })
  };
};

export const makeSsJoinParamByExpertCommentPage = (
  serviceId?: string,
  mediaId?: string,
  articleId?: string,
  isPay?: boolean,
  isPurchesed?: boolean
): { type: string; id: string } | undefined => {
  if (!mediaId || !serviceId) {
    return undefined;
  }

  return {
    type: 'querystring',
    id: QueryString.stringify({
      shannon_service_id: serviceId,
      shannon_media_id: mediaId,
      page_type: 'comment',
      shannon_article_id: articleId,
      shannon_pay: isPay,
      is_purchased: isPurchesed
    })
  };
};
